import { LineTileShape } from './common'

export const defaultScrollHeight = 900

export const scrollOptions = {
  HomeScroll: {
    offset: 0,
    containerId: 'HomeScrollContainer',
    height: defaultScrollHeight,
  },
  HomeScrollWithStage: {
    offset: 0,
    containerId: 'HomeScrollWithStageContainer',
    height: 900,
  },
  CalendarScroll: {
    offset: 0,
    containerId: 'CalendarScrollContainer',
    height: defaultScrollHeight,
  },
  ListPageScroll: {
    [LineTileShape.SQUARE]: {
      offset: -264,
      containerId: 'ListPageScrollContainer',
      height: 1080 - 200 + 24,
      paddingBottom: 30,
    },
    [LineTileShape.CIRCLE]: {
      offset: -264,
      containerId: 'ListPageScrollContainer',
      height: 1080 - 200 + 24,
      paddingBottom: 30,
    },
    [LineTileShape.ASPECT16x9]: {
      offset: -264,
      containerId: 'ListPageScrollContainer',
      height: 1080 - 200 + 24,
      paddingBottom: 30,
    },
    [LineTileShape.ASPECT2x3]: {
      offset: -372,
      containerId: 'ListPageScrollContainer',
      height: 1080 - 200 + 24,
      paddingBottom: 30,
    },
    [LineTileShape.ASPECT9x16]: {
      offset: -432,
      containerId: 'ListPageScrollContainer',
      height: 1080 - 200 + 24,
      paddingBottom: 30,
    },
  },
  CataloguePageScroll: {
    squareType: {
      offset: -248,
      containerId: 'CataloguePageScrollContainer',
      height: 1080 - 200 + 24,
      paddingBottom: 30,
    },
    classicType: {
      offset: -264,
      containerId: 'CataloguePageScrollContainer',
      height: 1080 - 200 + 24,
      paddingBottom: 30,
    },
  },
  HomeTabPageScroll: {
    offset: 0,
    containerId: 'HomeTabPageScrollContainer',
    height: 1080 - 200 + 24,
  },
  ChannelsListHomeClassicScroll: {
    offset: -244,
    containerId: 'ChannelsListScroll',
    // smooth: 'easeOutQuint',
    // duration: 300,
    height: 602,
  },
  ChannelsListGridScroll: {
    offset: -232,
    containerId: 'ChannelsListScroll',
    height: 456,
  },
  EventDetailPageScroll: {
    offset: 0,
    containerId: 'EventDetailPageScrollContainer',
    height: 0,
  },
  SettingsPanelScroll: {
    offset: -240,
    containerId: 'SettingsPanelScroll',
    height: 700,
  },
  SubscriptionsPanelScroll: {
    offset: -539,
    containerId: 'SubscriptionsPanelScroll',
    height: 700,
    horizontal: true,
    duration: 0,
    smooth: true,
    ignoreCancelEvents: true,
  },
  PlayerChannelsScroll: {
    offset: 0,
    containerId: 'PlayerChannelsScroll',
    height: defaultScrollHeight,
  },
  TabScroll: {
    tabsNav: {
      height: 72,
      width: 1584,
      offset: -650,
      horizontal: true,
      duration: 150,
      smooth: true,
      containerId: 'TabsScrollContainer',
      ignoreCancelEvents: true,
    },
    highlights: {
      offset: 0,
      containerId: 'TabScroll.highlights',
      height: 1080 - 322,
      paddingBottom: 194,
    },
    eventsAndClips: {
      offset: 0,
      containerId: 'TabScroll.eventsAndClips',
      height: 1080 - 322,
    },
    catalogue: {
      offset: -264,
      containerId: 'TabScroll.Catalogue',
      height: 1080 - 322,
      paddingBottom: 30,
    },
  },
  PageScroll: {
    offset: 0,
    containerId: 'PageScroll',
    height: 1080 - 200,
    paddingBottom: 364,
  },
  LandingPageScroll: {
    offset: 0,
    containerId: 'LandingPageScroll',
    height: 1080,
    paddingBottom: 60,
  },
  MenuScroll: {
    offset: -466,
    containerId: 'MenuScroll',
    // smooth: 'easeOutQuint',
    // duration: 300,
    height: 988,
  },
  SelectListScroll: {
    offset: 0,
    containerId: 'SelectListScroll',
    // smooth: 'easeOutQuint',
    // duration: 300,
    height: 432,
  },
  YouTubeScroll: {
    offset: -720,
    containerId: 'YouTubeScroll',
    height: 860,
  },
  UsercentricsScroll: {
    offset: -70,
    containerId: 'Usercentricscroll',
    height: 830,
    smooth: 'easeOutQuart',
    duration: 500,
  },
  Search: {
    offset: 0,
    containerId: 'SearchScrollContainer',
    height: 791,
  },
  DeveloperScroll: {
    offset: 0,
    containerId: 'DeveloperScrollContainer',
    height: 800,
  },
  MatchesHorizontalScroll: {
    containerId: 'MatchesScrollContainer',
    horizontal: true,
    smooth: true,
    offset: -72,
    width: 1768,
    duration: 0,
  },
} as const
